import { Icons } from '@silverfort/sf-components';
import { BlockPage } from '../../../routings/pages/BlockPage/BlockPage';
import mainImage from './mainImage.png';

export const ISPMBlockPage = () => {
    const topics = [
        'Establish a hygienic, secure, and compliant environment',
        'Analyze over 200+ risk exposures',
        'Mitigate vulnerable touch points by proactively hardening identity systems',
        'Get actionable and automated recommendations to eliminate identity issues'
    ];
    return (
        <BlockPage
            leftContent={{ title: 'Identity Security Posture Management', image: mainImage }}
            rightContent={{
                title: 'Reduce Your Attack Surface',
                icon: Icons.IdentitySearch,
                description:
                    'Investigate, prioritize, and resolve risk across your organization, whether in your AD or cloud IdPs.',
                topics,
                accessLink: 'https://www.silverfort.com/ispm-signup/?utm_source=PQL&utm_content=main'
            }}
        />
    );
};
